import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_WORKFLOW_TEMPLATES } from '@/lib/constants/api'
import buildInitialState from '@/store/helpers/buildInitialState'
import updateStatus from '@/store/helpers/updateStatus'
import { notifySuccess, notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const workflowTemplateTasks = {
  namespaced: true,
  state: buildInitialState({
    workflowTemplateTaskList: []
  }),
  getters: {
    getField
  },
  actions: {
    getWorkflowTemplateTasks ({ commit, dispatch }, templateId) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Loading tasks, please wait...' })

      return api.doGet({ path: `${PATH_WORKFLOW_TEMPLATES}/${templateId}/tasks` })
        .then(json => json.data)
        .then(tasks => {
          commit('updateStatus', { status: COMPLETE })
          commit('setWorkflowTemplateTasks', tasks)
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to load tasks')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    deleteWorkflowTemplateTask ({ commit, dispatch }, { templateId, taskId }) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Deleting task, please wait...' })
      return api.doDelete({ path: `${PATH_WORKFLOW_TEMPLATES}/${templateId}/tasks/${taskId}` })
        .then(() => {
          commit('updateStatus', { status: COMPLETE })
          notifySuccess(dispatch, 'Task deleted')
          return dispatch('getWorkflowTemplateTasks', templateId)
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, error || 'Unable to delete task')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    reorderWorkflowTemplateTasks ({ commit, dispatch }, { templateId, orderedTaskIds }) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Reordering tasks, please wait...' })
      return api.doPut({
        path: `${PATH_WORKFLOW_TEMPLATES}/${templateId}/tasks/reorder`,
        data: orderedTaskIds
      })
        .then(json => json.data)
        .then(tasks => {
          commit('updateStatus', { status: COMPLETE })
          commit('setWorkflowTemplateTasks', tasks)
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, error || 'Unable to reorder tasks')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    }
  },
  mutations: {
    updateStatus,
    updateField,
    setWorkflowTemplateTasks (state, tasks) {
      state.workflowTemplateTaskList = tasks
    }
  }
}

export default workflowTemplateTasks
